import { FeedbackData } from '../types';

const BASE_URL = process.env.REACT_APP_BACKEND_URL.replace(/\/$/, '');

/**
 * Submits user feedback to the backend server.
 */
export const submitFeedback = async (feedbackData: FeedbackData): Promise<{ success: boolean; message: string }> => {
  try {
    const response = await fetch(`${BASE_URL}/api/feedback`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(feedbackData),
    });

    if (!response.ok) {
        // Try to parse error message from server, fallback to generic message
        const errorData = await response.json().catch(() => ({ message: 'An unknown server error occurred.' }));
        throw new Error(errorData.message || `Server responded with status: ${response.status}`);
    }

    return { success: true, message: "Feedback submitted successfully. Thank you!" };

  } catch (error) {
    console.error("Error submitting feedback:", error);
    const errorMessage = error instanceof Error ? error.message : "An unknown error occurred.";
    return { success: false, message: `Could not reach the server. Please try again later. (${errorMessage})` };
  }
};